import selectOptionDict from '@/store/dict/selectOptionDict'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  const headData = [
    {
      name: 'id',
      columnProps: {
        prop: 'id',
        label: '采购订单ID',
        width: 110,
      },
      render: ({ row }) => {
        return <span class="a-hover-link" onClick={() => this.handleOrderIdClick(row.id)}>{row.id}</span>
      },
    },
    {
      name: 'carTotalNum',
      columnProps: {
        prop: 'carTotalNum',
        label: '采购车辆数',
        width: 100,
      },
    },
    {
      name: 'processCarNum',
      columnProps: {
        prop: 'processCarNum',
        label: '有效车辆数',
        width: 100,
      },
    },
    {
      name: 'returnCarNum',
      columnProps: {
        prop: 'returnCarNum',
        label: '订单退车数',
        width: 100,
      },
    },
    {
      name: 'providerName',
      columnProps: {
        prop: 'providerName',
        label: '车源方',
        width: 160,
      },
    },
    {
      name: 'gmtCreate',
      columnProps: {
        prop: 'gmtCreate',
        label: '订单创建时间',
        width: 160,
      },
    },
    {
      name: 'contractStartDate',
      columnProps: {
        prop: 'contractStartDate',
        label: '合同开始日期',
        width: 120,
      },
    },
    {
      name: 'contractEndDate',
      columnProps: {
        prop: 'contractEndDate',
        label: '合同结束日期',
        width: 120,
      },
    },
    {
      name: 'closeTime',
      columnProps: {
        prop: 'closeTime',
        label: '订单关闭时间',
        width: 160,
      },
    },
    {
      name: 'purchaseMode',
      columnProps: {
        prop: 'purchaseMode',
        label: '采购方式',
      },
      getText: ({ row }) => selectOptionDict.purchaseTypeDict[row.purchaseMode],
    },
    {
      name: 'payForm',
      columnProps: {
        prop: 'payForm',
        label: '支付形式',
        width: 110,
      },
      getText: ({ row }) => selectOptionDict.paymentformDict[row.payForm],
    },
    {
      name: 'state',
      columnProps: {
        prop: 'state',
        label: '订单状态',
      },
      getText: ({ row }) => selectOptionDict.purchaseStateDict[row.state],
    },
    {
      name: 'deptName',
      columnProps: {
        prop: 'deptName',
        label: '所属部门',
      },
    },
    {
      name: 'operate',
      columnProps: {
        label: '操作',
        fixed: 'right',
        width: 240,
      },
      maxShowLength: operateMaxShowLength,
      type: 'operate',
      getOperateList: ({ row }) => {
        const btnArr = []
        // 2 进行中
        if (row.state === 2) {
          this.judgePermission('purchase_new_order_list_additional') && btnArr.push({
            name: 'addCarsOperation',
            label: '新增采购车辆',
            action: () => this.addCarsOperation(row),
          })
          this.judgePermission('purchase_new_order_list_batch_return_car') && btnArr.push({
            name: 'returnCarOperation',
            label: '批量退车',
            action: () => { this.returnCarOperation(row) },
          })
          this.judgePermission('purchase_new_order_list_close') && btnArr.push({
            name: 'closeOrder',
            label: '订单关闭',
            action: () => this.getVoidComplete(row),
          })
        }
        return btnArr
      },
    },
  ]

  return { headData }
}
